import { Box, styled, Typography } from "@material-ui/core";
import {
  EPOCUS_PRIMARY,
  EPOCUS_SELECTED_BG,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../_lib/epocus-palette";
import { useEpocusRole } from "../../_lib/rbac/epocus-claim";
import { roleLabel } from "../../_lib/rbac/role-label";
import { SettingsCard } from "./settings-card";

const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

const Avatar = styled(Box)({
  width: 44,
  height: 44,
  flexShrink: 0,
  borderRadius: "50%",
  backgroundColor: EPOCUS_PRIMARY,
  color: EPOCUS_WHITE,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: rem(15),
});

const Name = styled(Typography)({
  fontSize: rem(16),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const MetaRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 6,
  marginTop: 3,
});

const RoleChip = styled("span")({
  backgroundColor: EPOCUS_SELECTED_BG,
  color: EPOCUS_PRIMARY,
  fontSize: rem(10),
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  padding: "3px 8px",
  borderRadius: 999,
});

const ProgramName = styled(Typography)({
  fontSize: rem(13),
  color: EPOCUS_TEXT_SECONDARY,
});

const initials = (parts: readonly (string | null | undefined)[]): string =>
  parts
    .map((part) => part?.trim().charAt(0) ?? "")
    .join("")
    .toUpperCase();

export const IdentityHeader: FC<{
  firstname?: string | null;
  lastname?: string | null;
  programName?: string | null;
}> = ({ firstname, lastname, programName }) => {
  const role = useEpocusRole();
  const fullName = [firstname, lastname]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  const monogram = initials([firstname, lastname]);

  return (
    <SettingsCard>
      <Row>
        {monogram && <Avatar aria-hidden>{monogram}</Avatar>}
        <Box>
          {fullName && <Name>{fullName}</Name>}
          <MetaRow>
            {role && <RoleChip>{roleLabel(role)}</RoleChip>}
            {programName && <ProgramName>{programName}</ProgramName>}
          </MetaRow>
        </Box>
      </Row>
    </SettingsCard>
  );
};
